import { useEffect, useRef, useState } from 'react';

/** 메뉴 한 줄 — 데이터로 넘겨 메뉴 모양과 동작을 떼어 둔다(항목을 더하거나 빼기 쉽게). */
export interface MenuItem {
  label: string;
  onSelect: () => void;
  /** 못 쓰는 이유(있으면 잠그고 툴팁으로 보인다). */
  disabledReason?: string | null;
  danger?: boolean;
}

/**
 * 그룹 머리의 [⋯] 메뉴(관리자, 설계서 §14.20). 바깥을 누르거나 Esc 면 닫힌다.
 * 행의 클릭·더블클릭(접기·접속)으로 새지 않게 전파를 끊는다.
 */
export function GroupMenu({ items, label = '그룹 메뉴' }: { items: MenuItem[]; label?: string }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (!open) return;
    const close = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const esc = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('mousedown', close);
    document.addEventListener('keydown', esc);
    return () => {
      document.removeEventListener('mousedown', close);
      document.removeEventListener('keydown', esc);
    };
  }, [open]);

  return (
    <span className="gtree-menu" ref={ref} onClick={(e) => e.stopPropagation()} onDoubleClick={(e) => e.stopPropagation()}>
      <button className="ghost gtree-menu-btn" aria-label={label} aria-expanded={open} title={label} onClick={() => setOpen((o) => !o)}>
        ⋯
      </button>
      {open && (
        <span className="gtree-menu-list" role="menu">
          {items.map((it) => (
            <button
              key={it.label}
              role="menuitem"
              className={`gtree-menu-item${it.danger ? ' danger' : ''}`}
              disabled={!!it.disabledReason}
              title={it.disabledReason ?? undefined}
              onClick={() => {
                setOpen(false);
                it.onSelect();
              }}
            >
              {it.label}
            </button>
          ))}
        </span>
      )}
    </span>
  );
}
